import React, { ReactNode } from "react";

interface PageTitleProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, actions }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 py-2">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {subtitle}
          </p>
        )}
      </div>

      {actions && <div className="mt-4 sm:mt-0 flex-shrink-0">{actions}</div>}
    </div>
  );
};

export default PageTitle;
